import { getCurrentUser, signIn, signOut, fetchAuthSession } from 'aws-amplify/auth'

export const adminAuthService = {
  async getCurrentAdmin() {
    try {
      const user = await getCurrentUser()
      const session = await fetchAuthSession()
      
      if (!session.tokens) {
        return null
      }
      
      return { ...user, session }
    } catch (error) {
      return null
    }
  },

  async signIn(email: string, password: string) {
    try {
      const result = await signIn({ 
        username: email, 
        password 
      })
      return result
    } catch (error) {
      throw error
    }
  },

  async signOut() {
    try {
      await signOut({ global: true })
    } catch (error) {
      throw error
    }
  },

  async getSession() {
    try {
      const session = await fetchAuthSession()
      
      if (!session.tokens) {
        return null
      }
      
      return session
    } catch (error) {
      return null
    }
  },

  async verifySession() {
    try {
      const session = await fetchAuthSession({ forceRefresh: true })
      return session.tokens !== undefined
    } catch (error) {
      return false
    }
  }
}